import React, { useState } from "react";
import createPrivateAdminPanelInstance from "../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../api/ApiRoutes";

import "./stylesDeleteRowPopup.css";
import { X } from "react-feather";
import CheckBox from "../../CommonComponents/CheckBox/CheckBox";
import { AppStrings } from "../../../utils/constants/AppStrings";

function DeleteRowPopup({
  isVisible,
  onClosePressed,
  getRedemptionsPending,
  selectedRow,
}) {
  const token = JSON.parse(localStorage.getItem("token"));

  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.AccessToken
  );

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isCheckBoxChecked, setIsCheckBoxChecked] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const buttonDisabled = !isCheckBoxChecked;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setSuccessMessage("");

    if (buttonDisabled || !selectedRow) {
      return;
    }

    setIsSubmitting(true);

    const params = {
      user_id: selectedRow.user_id,
      transaction_id: selectedRow.transaction_id,
    };

    try {
      await PrivateAdminPanelInstance?.delete(API_ROUTES?.DELETE_SINGLE_PENDING_REDEMPTION?.replace("{user_id}", params?.user_id)?.replace("{transaction_id}", params?.transaction_id), params);

      setSuccessMessage(AppStrings.TRANSACTION_DELETED_SUCCESSFULLY);

      await getRedemptionsPending();
      onClosePressed();
    } catch (error) {
      setErrorMessage(error?.response?.data?.message || AppStrings.ERROR_DELETING_TRANSACTION);
      console.log("Error adding event code:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClosePressed = () => {
    onClosePressed();
    setIsCheckBoxChecked(false);
    setIsSubmitting(false);
    setSuccessMessage("");
    setErrorMessage("");
  };

  const handleCheckBoxPressed = () => {
    setIsCheckBoxChecked(!isCheckBoxChecked);
  };

  if (!isVisible) return null;
  return (
    <div className="delete-row-popup">
      <div className="delete-row-panel">
        {successMessage && <p className="success-message">{successMessage}</p>}
        {errorMessage && <p className="error-message">{errorMessage}</p>}
        <div className="delete-row-panel-header">
          <p>{AppStrings.DELETE_SELECTED_ROW_USERNAME_TRANSACTION.replace("{selectedRow.username}", selectedRow.username)}</p>
          <button className="close-button" onClick={handleClosePressed}>
            <X className="close-icon" />
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="checkbox-container">
            <CheckBox
              className="delete-check-box"
              onClicked={handleCheckBoxPressed}
              isSelected={isCheckBoxChecked}
              width={"30px"}
              height={"30px"}
              border_radius={"8px"}
            />

            <div className="delete-check-text">
              {AppStrings.I_UNDERSTAND_THAT_THIS_IS_PERMANENT}
            </div>
          </div>

          <button
            type="submit"
            disabled={buttonDisabled}
            className={`submit-button ${
              buttonDisabled || isSubmitting ? "disabled" : null
            }`}
          >
            {isSubmitting ? AppStrings.DELETING : AppStrings.DELETE}
          </button>
        </form>
      </div>
    </div>
  );
}

export default DeleteRowPopup;
